import { QRCodeSVG } from "qrcode.react";
import { Text } from "@ttc3k/trekker";
import { Flex } from "styled-system/jsx";
import { useTranslation } from "react-i18next";

type KioskQRCodeProps = {
  url: string;
};

export const KioskQRCode = ({ url }: KioskQRCodeProps) => {
  const { t } = useTranslation();

  return (
    <Flex
      flexDir="column"
      alignItems="center"
      gap="200"
      py="400"
      px="300"
      border="1px solid"
      borderColor="border.light"
      borderRadius="lg"
      bg="white"
      part="details__kiosk-qr"
    >
      <QRCodeSVG
        value={url}
        size={160}
        level="M"
        marginSize={2}
      />
      <Text visual="smallMedium" color="text.mid" textAlign="center">
        {t("widgets:OPERATOR.DETAILS_SIDE_PANE.SCAN_QR")}
      </Text>
    </Flex>
  );
};
